module.exports = __webpack_public_path__ + "606ea07b25181a2cac7557f3b2042568.svg";